var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _circle, _path6, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseUploadSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.65 89.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#858585;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#32b560;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.26px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.0-DL-upload-success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,8.93V68.55H114.51V8.93ZM110.25,64.29H12.69V13.19h97.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.92,16.7H16.25V60.3H53.92ZM50,20.62V51.11a16.21,16.21,0,0,0-9.43-9,11.17,11.17,0,0,0,3.86-8.63c0-5.89-4.19-10.68-9.34-10.68s-9.34,4.79-9.34,10.68a11.21,11.21,0,0,0,3.86,8.63,16.23,16.23,0,0,0-9.43,9V20.62ZM35.08,40.55c-3.16,0-5.72-3.17-5.72-7.07s2.56-7.06,5.72-7.06,5.73,3.17,5.73,7.06S38.24,40.55,35.08,40.55ZM47.25,56.38H22.91a12.2,12.2,0,0,1,24.34,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.81,
    y: 34.91,
    width: 45.62,
    height: 3.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.81,
    y: 42.06,
    width: 45.62,
    height: 3.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.81,
    y: 49.22,
    width: 45.62,
    height: 3.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.81,
    y: 56.38,
    width: 45.62,
    height: 3.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.45,16.78H59.63V31.21h45.82Zm-3.77,10.66H63.4v-6.9h38.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.38,85.67a24.95,24.95,0,1,1,24.94-24.94A25,25,0,0,1,112.38,85.67Zm0-35.4a10.46,10.46,0,1,0,10.46,10.46A10.47,10.47,0,0,0,112.38,50.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.38,50.27a10.46,10.46,0,1,0,10.46,10.46A10.47,10.47,0,0,0,112.38,50.27Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 112.38,
    cy: 60.73,
    r: 17.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.38,80.56a19.83,19.83,0,1,1,19.83-19.83A19.86,19.86,0,0,1,112.38,80.56Zm0-35.4A15.57,15.57,0,1,0,128,60.73,15.58,15.58,0,0,0,112.38,45.16Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "104.1 61.95 110.12 67.97 120.66 53.48"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseUploadSuccess);
export default __webpack_public_path__ + "static/media/license-upload-success.54223e451f2af7d551cbccebf3b8f673.svg";
export { ForwardRef as ReactComponent };